import { get } from 'lodash-es';

import contracts from './contract.json';
import dashboards from './dashboard.json';
import menu from './menu.json';
import login from './login.json';
import party from './party.json';
import products from './product.json';
import quotations from './quotation.json';
import settings from './setting.json';
import survey from './survey.json';
import salesroutes from './salesroute.json';
import stats from './stats.json';

// custom
import { customLocales } from './customer';

const locales = {
  contracts: { ...contracts, ...get(customLocales, 'contract', {}) },
  dashboards: { ...dashboards, ...get(customLocales, 'dashboard', {}) },
  menu: { ...menu, ...get(customLocales, 'menu', {}) },
  login: { ...login, ...get(customLocales, 'login', {}) },
  party: { ...party, ...get(customLocales, 'party', {}) },
  products: { ...products, ...get(customLocales, 'product', {}) },
  quotations: { ...quotations, ...get(customLocales, 'quotation', {}) },
  settings: { ...settings, ...get(customLocales, 'setting', {}) },
  survey: { ...survey, ...get(customLocales, 'survey', {}) },
  salesroutes: { ...salesroutes, ...get(customLocales, 'salesroute', {}) },
  stats: { ...stats, ...get(customLocales, 'stats', {}) },
};

export default locales;
